import { useRef, useEffect, useState, useContext } from 'react';

import dynamicClass from 'clsx';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import Cookies from 'universal-cookie';

import Checkbox from '@/components/atoms/checkbox/checkbox';
import GenericToast from '@/components/atoms/generic-toast/genericToast';
import Input from '@/components/atoms/input/input';
import Select from '@/components/atoms/select/select';
import FormAndNoteTemplate from '@/components/organisms/form-and-note-template/formAndNoteTemplate';
import UseDocumentType from '@/hooks/UseDocumentType';

import UseTraceItemShipping from '@/hooks/UseTraceItemShipping';
import * as reCaptchaKey from '../../../constants/reCaptcha';
import listTypeDoc from '../../../utils/typeDoc.json';
import { postLegal, getHouseAllowingCertificate } from '../../../services/certificate-services';
import listTypeDocLegal from '../../../utils/typeDocLegal.json';

import GlobalContext from '../../../contexts/globalContext';

import './housingAllowanceForm.scss';

const HousingAllowanceForm = ({ contentInfo, setCurrentStep, setPostulationInfoData }: any) => {
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const recaptchaRef = useRef<any>();
  const { gigyaContext, userInfoContext } = useContext(GlobalContext);
  const [isLogged, setIsLogged] = useState(false);
  const [isActiveTermsOne, setIsActiveTermsOne] = useState(false);
  const [isActiveTermsTwo, setIsActiveTermsTwo] = useState(false);
  const [openToast, setOpenToast] = useState<any>(false);
  const [documentName, setdocumentName] = useState('');
  const [loader, setLoader] = useState(false);
  const cookies = new Cookies();

  const handleCheckbox = (type: any) => {
    if (type === 'one') {
      setIsActiveTermsOne(!isActiveTermsOne);
      setValue('termsOne', !isActiveTermsOne);
    } else {
      setIsActiveTermsTwo(!isActiveTermsTwo);
      setValue('termsTwo', !isActiveTermsTwo);
    }
  };

  const checkboxClass = dynamicClass({
    'm-request-form-shift__checkbox__size': true,
    'm-request-form-shift__checkbox--error': errors.terms,
  });

  const onAcceptTerms = (type): any => {
    if (type === 'one') {
      setIsActiveTermsOne(!isActiveTermsOne);
      setValue('termsOne', !isActiveTermsOne);
    } else {
      setIsActiveTermsTwo(!isActiveTermsTwo);
      setValue('termsTwo', !isActiveTermsTwo);
    }
  };

  useEffect(() => {
    if (recaptchaRef && recaptchaRef.current) {
      recaptchaRef.current.execute();
    }
  }, []);

  const onSubmit = async (data) => {
    setLoader(true);
    const { documentNumber, documentType, formNumber } = data;
    const docType = UseDocumentType(documentType).tipoDocumentoLegdos;
    const completeFormNumber = formNumber.toString().padStart(10, '0');

    if (!isLogged) {
      const userTypeDoc = listTypeDocLegal.filter(
        (item) => item.typaDocSAP === data.documentType || item.name === data.documentType,
      )?.[0]?.legal;
      postLegal(data.documentNumber, userTypeDoc, 'aleatorio@gmail.com');
      UseTraceItemShipping(
        '',
        data.documentNumber,
        data.documentType,
        'usuarioNoLogeado@gmail.com',
        'click',
        'CertificadosYConsultas :: ConsultaPostulacionVivienda :: } ClickBotonConsultar',
        cookies.get('token'),
      );
    } else {
      UseTraceItemShipping(
        `${gigyaContext?.gigyaAccount?.profile.firstName} ${
          gigyaContext?.gigyaAccount?.data.secondName
            ? `${gigyaContext.gigyaAccount.data.secondName} `
            : ''
        }${gigyaContext?.gigyaAccount?.profile.lastName}${
          gigyaContext?.gigyaAccount?.data.secondLastName
            ? ` ${gigyaContext.gigyaAccount.data.secondLastName}`
            : ''
        }`,
        gigyaContext?.gigyaAccount?.data.docNumber,
        gigyaContext?.gigyaAccount?.data.docType,
        gigyaContext?.gigyaAccount?.profile.email,
        'click',
        'CertificadosYConsultas :: ConsultaPostulacionVivienda :: } ClickBotonConsultar',
        userInfoContext.data?.userJwt,
      );
    }
    const response = await getHouseAllowingCertificate(documentNumber, docType, completeFormNumber);
    if (response.status === 200 && response.data.status === 200) {
      setPostulationInfoData(response.data.data);
      setLoader(false);
      setCurrentStep(2);
    } else {
      if (response.data.status === 404) {
        const defaultData = {
          estadoPostulacion: 'Not found',
        };
        setPostulationInfoData(defaultData);
        setLoader(false);
        setCurrentStep(2);
      }
      setLoader(false);
      alertError(response?.data?.userMessage);
    }
    //   recaptchaRef.current.execute()
    //   if (recaptchaRef.current.getValue()) {
    //     console.log(data)
    //     setCurrentStep(1)
    //     if (!isLogged) {
    //       const userTypeDoc = listTypeDocLegal.filter(
    //         (item) =>
    //           item.typaDocSAP === data.documentType ||
    //           item.name === data.documentType
    //       )?.[0]?.legal
    //       postLegal(data.documentNumber, userTypeDoc, "aleatorio@gmail.com")
    //     }
    //   }
    // }
  };

  const alertError = (userMessage: string) => {
    return setOpenToast(
      <GenericToast
        message={userMessage}
        position="up-right-small"
        setActiveToast={setOpenToast}
        size="small"
      />,
    );
  };

  useEffect(() => {
    if (gigyaContext.gigyaAccount) {
      const userTypeDocument = listTypeDoc.filter(
        (item) => item.typaDocSAP === gigyaContext?.gigyaAccount?.data.docType,
      )[0].name;
      setdocumentName(userTypeDocument);
      setIsLogged(true);
      setValue('documentType', userTypeDocument);
      setValue('documentNumber', gigyaContext.gigyaAccount.data.docNumber);
      setIsActiveTermsOne(true);
      setIsActiveTermsTwo(true);
    }
  }, []);

  return (
    <>
      {openToast && <>{openToast}</>}
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={reCaptchaKey.key} />
      <FormAndNoteTemplate
        desiredTab="none"
        buttonCopy={contentInfo.referencias[0].boton[0].copy}
        buttonEvent={() => {
          handleSubmit(onSubmit)();
        }}
        note={{
          image: contentInfo.secciones[0].imagen[0],
          title: contentInfo.secciones[0].imagen[0].title,
          content: contentInfo.secciones[0].descripcion,
        }}
        notePosition="left"
        disableButton={!(isActiveTermsOne && isActiveTermsTwo)}
        loader={loader}
      >
        <form onSubmit={handleSubmit(onSubmit)} className="m-request-form">
          <div className="m-request-form__input">
            <Select
              label={
                contentInfo.referencias[0].referencias[0].nombre
                  ? contentInfo.referencias[0].referencias[0].nombre
                  : 'Tipo de documento'
              }
              name="documentType"
              register={register}
              options={contentInfo.referencias[0].referencias[0].listaJson}
              setValue={setValue}
              square
              validationRules={{
                required: {
                  value: true,
                  message: 'Campo requerido',
                },
              }}
              defaultValue={{
                name: contentInfo.referencias[0].referencias[0].subtitulo
                  ? contentInfo.referencias[0].referencias[0].subtitulo
                  : 'Selecciona una opción',
                value: '',
              }}
              forceChangeValue={
                gigyaContext?.gigyaAccount && {
                  name: documentName,
                  value: gigyaContext?.gigyaAccount?.data.docType,
                }
              }
              error={errors.requestType}
              required
              disabled={isLogged}
            />
          </div>
          <div className="m-request-form__input">
            <Input
              label={
                contentInfo.referencias[0].referencias[1].nombre
                  ? contentInfo.referencias[0].referencias[1].nombre
                  : 'Número de documento'
              }
              name="documentNumber"
              maxLength="25"
              type="number"
              square
              placeholder={
                contentInfo.referencias[0].referencias[1].subtitulo
                  ? contentInfo.referencias[0].referencias[1].subtitulo
                  : 'Escribe tu número de documento'
              }
              register={register}
              validationRules={{
                required: {
                  value: true,
                  message: 'Campo requerido',
                },
                pattern: {
                  value: /^[{0-9}]+$/,
                  message: 'No se permiten caracteres especiales',
                },
                maxLength: {
                  value: 25,
                  message: 'El documento no debe superar los 25 dígitos',
                },
                minLength: {
                  value: 5,
                  message: 'El documento debe tener al menos 5 dígitos',
                },
              }}
              setValue={setValue}
              required
              error={errors.documentNumber}
              disabled={isLogged}
            />
          </div>
          {!isLogged && (
            <>
              <div className="m-request-form__input">
                <Input
                  label={
                    contentInfo.referencias[0].referencias[2].nombre
                      ? contentInfo.referencias[0].referencias[2].nombre
                      : 'Número de formulario'
                  }
                  name="formNumber"
                  maxLength="20"
                  type="number"
                  square
                  placeholder={
                    contentInfo.referencias[0].referencias[2].subtitulo
                      ? contentInfo.referencias[0].referencias[2].subtitulo
                      : 'Escribe tu número de formulario'
                  }
                  register={register}
                  validationRules={{
                    required: {
                      value: true,
                      message: 'Campo requerido',
                    },
                    pattern: {
                      value: /^[{0-9}]+$/,
                      message: 'No se permiten caracteres especiales',
                    },
                    maxLength: {
                      value: 20,
                      message: 'El documento no debe superar los 20 dígitos',
                    },
                    minLength: {
                      value: 5,
                      message: 'El documento debe tener al menos 5 dígitos',
                    },
                  }}
                  tooltip={
                    contentInfo.referencias[0] &&
                    contentInfo.referencias[0].referencias[6] && (
                      <div className="m-housing-alowance-form__tooltip">
                        {contentInfo.referencias[0].referencias[6].nombre && (
                          <h3 className="m-housing-alowance-form__tooltip-title">
                            {contentInfo.referencias[0].referencias[6].nombre}
                          </h3>
                        )}
                        {contentInfo.referencias[0].referencias[6].subtitulo && (
                          <p className="m-housing-alowance-form__tooltip-subtitle">
                            {contentInfo.referencias[0].referencias[6].subtitulo}
                          </p>
                        )}
                      </div>
                    )
                  }
                  setValue={setValue}
                  required={!isLogged}
                  error={errors.formNumber}
                />
              </div>
              <div className="m-request-form-shift__checkContainer">
                <aside className="m-request-form-shift__checkContainer__checkbox">
                  <input
                    className="checkbox"
                    type="checkbox"
                    {...register('termsOne', {
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                    })}
                  />
                  <Checkbox
                    square
                    checkActive={isActiveTermsOne}
                    checkClick={() => handleCheckbox('one')}
                    className={checkboxClass}
                  />
                  <label className="label" onClick={() => onAcceptTerms('one')}>
                    {`${contentInfo.referencias[0].referencias[4].nombre} `}
                    <a
                      className="link"
                      href={contentInfo.referencias[0].referencias[4].redireccion}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {contentInfo.referencias[0].referencias[4].copyBoton}
                    </a>
                    {` ${contentInfo.referencias[0].referencias[4].subtitulo}`}
                  </label>
                </aside>
                <aside className="m-request-form-shift__checkContainer__checkbox">
                  <input
                    className="checkbox"
                    type="checkbox"
                    {...register('termsTwo', {
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                    })}
                  />
                  <Checkbox
                    square
                    checkActive={isActiveTermsTwo}
                    checkClick={() => handleCheckbox('two')}
                    className={checkboxClass}
                  />
                  <label className="label" onClick={() => onAcceptTerms('two')}>
                    {`${contentInfo.referencias[0].referencias[5].nombre} `}
                    <a
                      className="link"
                      href={contentInfo.referencias[0].referencias[5].redireccion}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {contentInfo.referencias[0].referencias[5].copyBoton}
                    </a>
                    {` ${contentInfo.referencias[0].referencias[5].subtitulo}`}
                  </label>
                </aside>
              </div>
            </>
          )}
        </form>
      </FormAndNoteTemplate>
    </>
  );
};

export default HousingAllowanceForm;
